import ManufactureWork from "./ManufactureWork";
import { observable } from "mobx";

class ManufactureListItem extends ManufactureWork {
    @observable checked: boolean = false;
    @observable listIndex: number = 0;
}

export default ManufactureListItem;